// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"78956cab","779":"e5ec5143"}[chunkId] + ".chunk.js";
};